import { render, staticRenderFns } from "./IconMarketGrade.vue?vue&type=template&id=1cfecfcf&"
import script from "./IconMarketGrade.vue?vue&type=script&lang=ts&"
export * from "./IconMarketGrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports